import React, {Suspense} from 'react';
import {Canvas} from '@react-three/fiber'
import Camera from "./Camera";
import CameraCustom from "./CameraCustom";
import Sky from "../scene/Sky";
import MoveBeetween from "./MoveBeetween";
import {Environment} from "@react-three/drei";
import HudStore from "./HudStore";
import HudError from "./HudError";
import Loader from "./Loader";
import ModalSuperPrize from "./ModalSuperPrize";
import TravelHud from "./TravelHud";
import ModalBackmove from "./ModalBackmove";
import HudEndGame from "./HudEndGame";
import { Islands } from '../scene/Islands';
import Tank from '../scene/Tank';
import useStore from '../store';
import FrameTime from './FrameTime';

function Game() {
    const setFlyMode = useStore(state => state.setFlyMode)
    const hash = window.location.hash
    React.useEffect(() => {
        if (hash === '#spectator') setFlyMode()
    }, [hash])
    return (
        <>
            <Suspense fallback={<Loader/>}>
                <Canvas
                    className="game-canvas"
                    dpr={[1, 2]}
                    >
                    <fog attach="fog" args={['#2E3A68', 270, 370]}/>


                    <Islands />
                    <Tank />
                    <Sky/>
                    <Environment files='https://web-cdn.tankionline.com/new-year/forest.hdr'/>
                    
                    <directionalLight intensity={0.8} position={[0, 100, 0]} color={"#3763ff"}></directionalLight>
                    <ambientLight intensity={0.25}  color={"#3763ff"}></ambientLight>

                    <Camera/>
                    <CameraCustom/>
                    <FrameTime />
                </Canvas>
                <MoveBeetween/>
                <HudStore/>
                <HudError/>
                <ModalBackmove/>
                <ModalSuperPrize/>
                <HudEndGame/>
            </Suspense>
            <TravelHud/>
        </>
    )

}

export default Game;
